import React from "react";

const CheckmarkIcon = ({ style, color = "green" }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m94.2573624 18.2838631c-4.323761-4.307004-11.3512192-4.307004-15.6749878 0l-39.899971 39.8999748-17.2645874-17.2645874c-2.1626453-2.1626472-4.9958782-3.243206-7.829114-3.243206-2.8499975 0-5.6832309 1.0805588-7.8458757 3.243206-4.3237667 4.3237686-4.3237667 11.3512192 0 15.6749916l25.1089401 25.1089439c2.0971088 2.0803452 4.864809 3.2432022 7.8291149 3.2432022 2.9643021 0 5.748764-1.1628571 7.8458748-3.2432022l47.7290878-47.7458534c4.3252869-4.3070049 4.3252869-11.3497009.0015183-15.6734695z"
        fill={color && color}
      />
    </svg>
  );
};

export default CheckmarkIcon;
